const state = {
  isAuth: false,
  logoUrl: '',
  logoLink: '',
  // mallName: '',
  userInfo: {},
  isCenter: false,
  channelMenu: '',
  channelMenuShowType: '',
  bottomContent: '',
  headerTopContent: '',
  isFunctionDepartment: null,
  nonDirType: '',
  nonDirLink: '',
  userInfoLocation: null,
  // 应用分类列表
  applicationClassifyList: [],
  // 所有菜单
  allMenu: {},
  // 页签框架 是否启用
  pageFrame: null,
  // 页签框架规则状态 0 已完成 1 加载中
  pageFrameStatus: 0,
  // 非商城名称配置
  nonCatalogName: {}
}
export default state
